import ApplicationComponent from "legacy/ApplicationComponent"
import SegmentedControl from "legacy/SegmentedControl"
import ReservationFlowController from "legacy/boater-reservation-flow/ReservationFlowController"
import InquiryFlowController from "legacy/boater-reservation-flow/boater-inquiry-flow/InquiryFlowController"
import { afterSetState, updateUrlQueryParams } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"

class BoaterBookingForm extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.forms = [
      { title: "Short Term", id: "transient" },
      { title: "Seasonal/Annual", id: "inquiry" },
    ]

    let initialForm = "transient"
    const preferredForm = this.forms
      .map((f) => f.id)
      .includes(this.props.preferredForm)
      ? this.props.preferredForm
      : "transient"
    switch (this.props.visibleForm) {
      case "both_forms":
        initialForm = preferredForm
        break
      case "marketplace_form":
        initialForm = "transient"
        break
      case "inquiry_form":
        initialForm = "inquiry"
        break
    }

    this.state = {
      currentForm: initialForm,
      hideHeader: false,
    }
    this.updateUrl = this.updateUrl.bind(this)
  }

  componentDidMount() {
    this.updateUrl()
  }

  updateUrl() {
    updateUrlQueryParams({ form: this.state.currentForm })
  }

  handleToggleChanged(selection) {
    this.setState({ currentForm: selection })
    if (selection === "inquiry") {
      Amplitude.trackEvent("inquiry_flow:make_an_inquiry_pressed", {
        experience_name: "inquiry_flow",
        marina_id: this.props.marina.mcom_id,
        marina_name: this.props.marina.name,
        visible_form: this.props.visibleForm,
      })
    }
    afterSetState(this.updateUrl)
  }

  hideHeader(hide) {
    this.setState({ hideHeader: hide })
  }

  formBody() {
    if (this.state.currentForm === "transient") {
      if (this.props.marina.inSeason) {
        return (
          <ReservationFlowController
            {...this.props.reservationFlow}
            androidRequest={this.props.androidRequest}
            hideHeader={this.hideHeader.bind(this)}
          />
        )
      } else {
        return this.renderOutOfSeasonSection()
      }
    } else if (this.state.currentForm === "inquiry") {
      return (
        <InquiryFlowController
          {...this.props.inquiryFlow}
          hideHeader={this.hideHeader.bind(this)}
          androidRequest={this.props.androidRequest}
          visibleForm={this.props.visibleForm}
          transactionTypes={this.props.inquiryTransactionTypes}
        />
      )
    }
  }

  renderHeader() {
    if (this.state.hideHeader) {
      return null
    }
    return (
      <div className="flex flex-col space-y-2 pt-3">
        <h2
          id="boaterBookingFormHeader"
          className="m-0 text-center text-2xl font-semibold text-gray-700"
        >
          {this.state.currentForm === "transient"
            ? "Reservations"
            : "General Inquiry"}
        </h2>
        {this.props.visibleForm === "both_forms" && <hr className="mx-0" />}
        {this.props.visibleForm === "both_forms" && (
          <SegmentedControl
            id="transientOrInquirySelector"
            style="gray"
            selectedSegment={this.state.currentForm}
            segments={this.forms}
            handleSelection={this.handleToggleChanged.bind(this)}
          />
        )}
      </div>
    )
  }

  renderOutOfSeasonSection() {
    const openingMessage = `${this.props.marina.name} is not currently accepting reservations.`
    return (
      <div className="p-4" id="outOfSeasonSection">
        <Badge color="critical" text="Out of Season" />
        <p className="pt-2" id="outOfSeasonMessage">
          {openingMessage} {this.outOfSeasonMessage()}
        </p>
      </div>
    )
  }

  outOfSeasonMessage() {
    const now = new Date()
    if (
      this.props.marina.reservationsAcceptedStartingAt &&
      new Date(this.props.marina.reservationsAcceptedStartingAt) > now
    ) {
      return (
        <p className="inline">
          {this.props.marina.name} will start accepting reservations for the
          upcoming season on
          <strong>
            {" "}
            {this.props.marina.reservationsAcceptedStartingAtFormatted}
          </strong>
          .
        </p>
      )
    } else {
      return (
        <p className="inline">
          Check back for updated information on the upcoming season.
        </p>
      )
    }
  }

  render() {
    return (
      <div id="boaterBookingFormContainer" className="card p-2">
        {this.renderHeader()}
        {this.formBody()}
      </div>
    )
  }
}

BoaterBookingForm.propTypes = {
  marina: PropTypes.shape({
    name: PropTypes.string.isRequired,
    mcom_id: PropTypes.string,
    inSeason: PropTypes.bool.isRequired,
    reservationsAcceptedStartingAt: PropTypes.string,
    reservationsAcceptedStartingAtFormatted: PropTypes.string,
  }).isRequired,
  preferredForm: PropTypes.string,
  visibleForm: PropTypes.oneOf([
    "both_forms",
    "marketplace_form",
    "inquiry_form",
  ]).isRequired,
  reservationFlow: PropTypes.shape({
    embedForm: PropTypes.bool,
  }).isRequired,
  inquiryFlow: PropTypes.object,
  androidRequest: PropTypes.bool,
  inquiryTransactionTypes: PropTypes.object,
}

export default BoaterBookingForm
